import { Navigate } from 'react-router-dom';

export const isInternal = import.meta.env.VITE_GLOBALVISION_INTERNAL === 'true';

export const InternalGuard = (props: { component: JSX.Element }) => {
  return isInternal ? props.component : <Navigate to="/" />;
};
